<template>
  <div>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="white"
      :height="60"
      flat
    >
      <v-app-bar-nav-icon
        @click="toggleNav((drawer = !drawer))"
        size="x-large"
        color="#ccc"
      />
      <v-spacer />

      <a href="/">
        <img class="d-md-none" :src="logoSm" width="75px" alt="ProMate" />
        <img
          class="d-none d-md-block"
          :src="logoSm"
          width="75px"
          alt="ProMate"
        />
      </a>
      <v-spacer />
      <v-btn icon size="large" v-if="false">
        <v-btn icon>
          <v-icon>mdi-bell</v-icon>
        </v-btn>
      </v-btn>
      <!-- <v-btn icon> <v-icon>mdi-bell</v-icon> </v-btn> -->
      <v-btn icon>
        <v-avatar item>
          <ProfileMenu @profileData="updateProfile($event)" />
        </v-avatar>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import ProfileMenu from "./ProfileMenu";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  components: { ProfileMenu },
  data: () => ({
    name: null,
    logo: require("@/assets/logo.png"),
    logoSm: require("@/assets/logo_sm.png"),
  }),

  computed: {
    drawer: {
      get() {
        return this.$store.state.auth.drawer;
      },
      set(value) {
        this.$store.commit("auth/setDrawer", value);
      },
    },
    notificationDrawer: {
      get() {
        return this.$store.state.auth.notificationDrawer;
      },
      set(value) {
        this.$store.commit("auth/setNotificationDrawer", value);
      },
    },

    ...mapGetters({}),
  },

  methods: {
    toggleNav: function(value) {
      this.$store.dispatch("auth/changeDrawer", value);
    },
    toggleNotificationDrawer: function(value) {
      this.$store.dispatch("auth/changeNotificationDrawer", value);
    },

    updateProfile(value) {
      this.name = value.display_name;
    },
  },
};
</script>
<style>
.v-toolbar__content {
  align-items: center;
  display: flex;
  position: relative;
  z-index: 0;
  border-bottom: solid 1px #e2e8f0;
}

.v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:first-child,
.v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:first-child {
  margin-left: -11px !important;
}
</style>
